// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e2e01f1b","641":"cb07ade9","785":"a9a92ea5"}[chunkId] + ".chunk.js";
};